/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const PrimeJeunesService = {
    async pushData(request: any, captchaToken: string) {
        if (request.bankAttestationFile) {
            request.bankAttestationFileName =
                'BankAttestation' +
                getFileExtension(request.bankAttestationFile);

            request.bankAttestationFile = await getFilePromise(
                request.bankAttestationFile
            );
        }

        request.schoolAttestationFileName =
            'SchoolAttestation' +
            getFileExtension(request.schoolAttestationFile);

        request.schoolAttestationFile = await getFilePromise(
            request.schoolAttestationFile
        );

        request.address =
            request.addressStreet +
            ' ' +
            request.addressNumber +
            ', ' +
            request.addressPostal +
            ' ' +
            request.addressLocality;

        request.addressLegalRepresentative =
            request.addressStreetLegalRepresentative +
            ' ' +
            request.addressNumberLegalRepresentative +
            ', ' +
            request.addressPostalLegalRepresentative +
            ' ' +
            request.addressLocalityLegalRepresentative;

        request.captchaToken = captchaToken;

        return await fetch('/api/FondsRebond/PushJeune', {
            method: 'POST',
            body: JSON.stringify(request),
            headers,
        });
    },
};

function getFileExtension(item: File): string {
    return '.' + item.name.split('.').pop();
}

function getFilePromise(file: any): Promise<any> {
    const filePromise = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as any);
    });

    return filePromise;
}
